import { HTMLExporter } from 'substance/dist/substance'

export default class ArticleExporter extends HTMLExporter {
  convertDocument (doc) {
    const elements = this.convertContainer(doc.get('body'))

    // TODO: avoid double-escaping the content
    // https://github.com/substance/substance/issues/1039

    return elements.map(el => el.outerHTML).join('')
  }
}



// WEBPACK FOOTER //
// ./src/ArticleExporter.js